import axios from "axios";

export const apiBaseUrl = import.meta.env.VITE_REACT_APP_API_URL;
export const socketBaseUrl = import.meta.env.VITE_REACT_APP_SOCKET_URL;

const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    
    if (token && !config.headers["Authorization"]) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (error.response.status === 401 && (!originalRequest.fetchOptions || !originalRequest.fetchOptions._retry)) {
      originalRequest.fetchOptions = {
        _retry: true
      }
      try {
        const refreshToken = localStorage.getItem("refresh_token")

        if(!refreshToken) return Promise.reject(error);

        const response = await api.get("/user/login/refresh/token", {
          headers: {
            Authorization: `Bearer ${refreshToken}`
          },
          fetchOptions: {
            _retry: true
          }
        })
        
        const newAccessToken = response.data.token;
        const newRefreshToken = response.data.refreshToken;

        localStorage.setItem('token', newAccessToken)
        localStorage.setItem('refresh_token', newRefreshToken)

        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return api(originalRequest);
      } catch (error: any) {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        if(window.location.pathname !== '/login'){
          window.location.href = "/login";
          return Promise.reject(error);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;